const baseConfig = {
  chart: {
    animation: false,
    backgroundColor: "#F7F7F7",
    marginRight: 20,
    marginLeft: 70,
    style: {
      fontFamily: "Ember-regular",
    },
  },
  colors: [
    "#13CE74",
    "#204172",
    "#E04B00",
    "#37A6E6",
    "#ECC032",
    "#333333",
    "#666666",
    "#999999",
    "#AAAAAA",
    "#CCCCCC",
    "#DDDDDD",
    "#EEEEEE",
    "#F7F7F7",
  ],
  title: {
    text: "",
    margin: 5,
  },
  xAxis: {
    labels: {
      enabled: true,
      style: {
        fontFamily: "Ember-regular",
        fontSize: "12px",
        color: "#999999",
        fill: "#999999",
      },
      rotation: 0,
    },
    lineColor: "#333333",
    minPadding: 0.01,
    maxPadding: 0,
    tickLength: 5,
    tickWidth: 2,
    tickColor: "#989898",
    minTickInterval: 1,
    title: {
      text: "",
    },
    minTickInterval: 1,
  },
  yAxis: {
    title: {
      text: undefined,
    },
    min: 0,
    gridLineWidth: "1.5px",
    gridLineColor: "#CCCCCC",
    labels: {
      x: -5,
      style: {
        fontFamily: "Ember-regular",
        fontSize: "12px",
        color: "#999999",
        fill: "#999999",
      },
    },
  },
  tooltip: {
    pointFormat: "{series.name}: <b>{point.y:,.2f}</b><br/>",
  },
  plotOptions: {
    area: {
      stacking: "normal",
      fillOpacity: 1,
      lineWidth: 0,
    },
    line: {
      lineWidth: 2,
      marker: {
        enabled: false,
        symbol: "circle",
      },
    },
    series: {
      animation: false,
      events: {
        legendItemClick: () => false, // disable legend click
      },
      marker: {
        enabled: false,
        symbol: "circle",
        states: {
          hover: {
            enabled: true,
          },
        },
      },
    },
  },
  credits: {
    enabled: false,
  },
  legend: {
    align: "left",
    margin: 26,
    squareSymbol: true,
    symbolRadius: 0,
    verticalAlign: "top",
    itemDistance: 16,
    alignColumns: false,
    itemStyle: {
      fontFamily: "Ember-regular",
      fontSize: "14px",
      color: "#333333",
      fontWeight: "400",
    },
  },
};

export default baseConfig;
